
import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { UserRightsMixin } from '@/mixins/UserRights';
import Project from '@/models/Project';
import InternalOrder from '@/models/InternalOrder';
import { TableInternalOrder } from '@/interfaces/components/projectNew/TableInternalOrder';
import { formatDateToDateString } from '@/helpers/LocaleHelper';

@Component({
    name: 'ProjectInternalOrders',
})
export default class ProjectInternalOrders extends mixins<UserRightsMixin>(UserRightsMixin) {
    @Prop({ default: null }) private project!: Project | null;
    @Prop({ default: false }) private customDateTitles!: { manufactureDate?: string; deliveryDate?: string };

    private get columns() {
        return [
            {
                title: this.$t('Internal order'),
                dataIndex: 'order',
                key: 'order',
            },
            {
                title: this.$t('System'),
                dataIndex: 'system',
                key: 'system',
            },
            {
                title: this.$t('Status'),
                dataIndex: 'status',
                key: 'status',
            },
            {
                title: this.$t('Date created'),
                dataIndex: 'dateCreated',
                key: 'dateCreated',
            },
            {
                title: this.$t(this.customDateTitles?.manufactureDate || 'Estimated manufacture date'),
                dataIndex: 'manufactureDate',
                key: 'manufactureDate',
            },
            {
                title: this.$t(this.customDateTitles?.deliveryDate || 'Estimated delivery date'),
                dataIndex: 'deliveryDate',
                key: 'deliveryDate',
            },
        ];
    }

    private internalOrderDate(order: InternalOrder, type: 'manufactureDate' | 'deliveryDate'): string {
        const dates = order?.projectInternalOrderDates[0] || [];

        switch (type) {
            case 'manufactureDate':
                return formatDateToDateString(dates?.manufacturedDate) || '-';
            case 'deliveryDate':
                return formatDateToDateString(dates?.deliveryDate) || formatDateToDateString(dates?.delivery) || '-';
            default:
                return '-';
        }
    }

    private get internalOrders(): TableInternalOrder[] {
        if (!this.project) {
            return [];
        }
        const orders = this.project.projectInternalOrders;

        if (!orders) {
            return [];
        }

        return orders.map((order: InternalOrder) => {
            return {
                key: order.id,
                order: order.orderNumber,
                system: this.$t(order.system),
                status: this.$t(order?.orderStatus?.code),
                dateCreated: formatDateToDateString(order.createdAt) || '-',
                manufactureDate: this.internalOrderDate(order, 'manufactureDate'),
                deliveryDate: this.internalOrderDate(order, 'deliveryDate'),
            };
        });
    }
}
